import { sagas as classifiedsSagas } from './modules/classifieds'

export default [...classifiedsSagas]
